import { formatDateTime } from "@/utils";
import ICON_GOAL from "@/assets/images/events/goal.svg";
import MatchMinute from "../KbvMatchMinute";

export default function LuMatchTime({
  isLive,
  isFinished,
  isNotStarted,
  matchTime,
  liveScore,
  status,
  halfStartTime,
  className,
  textAlignment = "center",
  cornerStacked = true,
  inline = false,
  currentHomeScore = 0,
  currentAwayScore = 0,
}) {
  const layoutClass =
    cornerStacked && !inline
      ? "flex flex-col items-center gap-1"
      : "flex flex-row items-center justify-between mt-0.5";

  const textClass = "text-[14px] leading-tight";

  if (isFinished) {
    if (inline) {
      return (
        <span
          className={`text-[12px] leading-tight whitespace-nowrap text-[var(--theme-text)] ${className || ""}`}
        >
          Kết Thúc {currentHomeScore}:{currentAwayScore}
        </span>
      );
    }
    return (
      <div className={`${layoutClass} min-w-fit box-border`}>
        <span
          className={`${textClass} whitespace-nowrap text-[var(--theme-text)]`}
        >
          Kết Thúc
        </span>
        <div className="flex items-center gap-1 whitespace-nowrap box-border">
          <img
            src={ICON_GOAL}
            alt="score"
            width={12}
            height={12}
            className="block kbv-lu-goal-icon kbv-corner-icon shrink-0 object-contain"
          />
          <span
            className={`${textClass} font-semibold text-[var(--theme-text)]`}
          >
            {currentHomeScore}:{currentAwayScore}
          </span>
        </div>
      </div>
    );
  }

  if (isNotStarted && matchTime) {
    const { date, time } = formatDateTime(matchTime);
    if (inline) {
      return (
        <span
          className={`text-[12px] leading-tight whitespace-nowrap text-[var(--theme-text)] box-border ${className || ""}`}
        >
          {time} - {date}
        </span>
      );
    }
    return (
      <div className="flex flex-col gap-1 min-w-fit whitespace-nowrap box-border">
        <span className={`${textClass} font-semibold text-[var(--theme-text)]`}>
          {time}
        </span>
        <span className={`${textClass} text-[var(--theme-text)]`}>{date}</span>
      </div>
    );
  }

  if (isLive && matchTime) {
    if (inline) {
      return (
        <span
          className={`flex w-full items-center justify-between gap-x-0 px-3 text-[12px] font-bold leading-tight whitespace-nowrap box-border ${className || ""}`}
        >
          <span className="flex flex-1 min-w-0 justify-end box-border">
            <MatchMinute
              liveScore={liveScore}
              status={status}
              matchTime={matchTime}
              halfStartTime={halfStartTime}
              className="leading-[1.2] text-[var(--theme-primary)]"
            />
          </span>
          <span className="flex min-w-[24px] shrink-0 items-center justify-center text-[var(--theme-text)] box-border">
            -
          </span>
          <span className="flex flex-1 min-w-0 justify-start font-bold text-[var(--theme-text)] box-border">
            {currentHomeScore}:{currentAwayScore}
          </span>
        </span>
      );
    }
    return (
      <div
        className={`${layoutClass} min-w-fit whitespace-nowrap box-border ${className || ""}`}
      >
        <MatchMinute
          liveScore={liveScore}
          status={status}
          matchTime={matchTime}
          halfStartTime={halfStartTime}
          className={`${textClass} font-bold leading-[1.2] text-[var(--theme-primary)] text-${textAlignment}`}
        />
        <div className="flex items-center gap-1 whitespace-nowrap box-border">
          <img
            src={ICON_GOAL}
            alt="score"
            width={12}
            height={12}
            className="block kbv-lu-goal-icon kbv-corner-icon shrink-0 object-contain"
          />
          <span
            className={`${textClass} font-semibold text-[var(--theme-text)]`}
          >
            {currentHomeScore}:{currentAwayScore}
          </span>
        </div>
      </div>
    );
  }

  if (matchTime) {
    const { date, time } = formatDateTime(matchTime);
    if (inline) {
      return (
        <span
          className={`text-[12px] leading-tight whitespace-nowrap text-[var(--theme-text)] box-border ${className || ""}`}
        >
          {time} - {date}
        </span>
      );
    }
    return (
      <div className="flex flex-col gap-1 min-w-fit whitespace-nowrap box-border">
        <span className={`${textClass} font-semibold text-[var(--theme-text)]`}>
          {time}
        </span>
        <span className={`${textClass} text-[var(--theme-text)]`}>{date}</span>
      </div>
    );
  }

  if (inline) {
    return (
      <span
        className={`text-[12px] leading-tight whitespace-nowrap text-[var(--theme-text)] box-border ${className || ""}`}
      >
        --:-- - --/--
      </span>
    );
  }
  return (
    <div className="flex flex-col gap-1 min-w-fit whitespace-nowrap box-border">
      <span className={`${textClass} font-semibold text-[var(--theme-text)]`}>
        --:--
      </span>
      <span className={`${textClass} text-[var(--theme-text)]`}>--/--</span>
    </div>
  );
}
